window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.superklubLoyaltyRepo = (function () {
    var url = "api/superklubloyalty";

    var get = function () {
        return fetch(url)
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(function (error) {
                // Vraća se sigurna prazna struktura
                console.warn('SuperKlub loyalty unavailable (silently ignored):', error);
                return { data: { challenges: [{ challenges: [] }] } };
            });
    };

    return {
        get: get
    };
})();
